export const INPUT_TAG = 'input';
export const INPUT_TYPE = 'text';
export const TEXTAREA_TAG = 'textarea';
export const FILTER_ID = 'filter';
